if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });

        queueMicrotask(() => this.autoSelectSecondOption());
      }

      autoSelectSecondOption() {
        if (this.dataset.autoSelectSecondOption !== 'true') return;

        const productView = this.closest('product-info') || this.parentElement || this;
        if (productView.autoSelectSecondOptionApplied) return;
        productView.autoSelectSecondOptionApplied = true;

        const matchingOptionNames = ['quantity', 'amount', 'choose a pack'];

        this.querySelectorAll('[data-option-name]').forEach((optionGroup) => {
          const optionName = optionGroup.dataset.optionName?.toLowerCase() || '';
          if (!matchingOptionNames.some((name) => optionName.includes(name))) return;

          const options = optionGroup.querySelectorAll('select option, input[type="radio"]');
          const secondOption = options[1];
          if (!secondOption || secondOption.dataset.optionAvailable !== 'true') return;

          const isDropdownOption = secondOption.tagName === 'OPTION';
          const control = isDropdownOption ? secondOption.closest('select') : secondOption;
          if (!control || (isDropdownOption ? secondOption.selected : secondOption.checked)) return;

          if (isDropdownOption) {
            control.value = secondOption.value;
          } else {
            secondOption.checked = true;
          }
          control.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
